export class QrefValutModel {
  kodVal: string;
  naimVal: string;
  constructor() {
  }
}

